import {SDKEventAttrs} from '@mparticle/web-sdk';
import {selectChannelData} from '../../store/slices/channel/slice';
import {
  selectTimeslots,
  selectNextAvailableDate,
  selectSelectedDate,
} from '../../store/slices/selectors';
import {RootState} from '../../hooks/store';
import dayjs from 'dayjs';
import {countDaysFromCurrentDate} from '../../utils/countDaysFromCurrentDate';

export const generateDateSelectedAttributes = ({
  state,
  isMobile,
}: {
  state: RootState;
  isMobile: boolean;
}) => {
  const channel = selectChannelData(state);
  const selectedDateTimeslots = selectTimeslots(state);
  const selectedDate = selectSelectedDate(state);
  const nextAvailableDateFromSelectedDate = selectNextAvailableDate(state);
  const daysDifference = countDaysFromCurrentDate();

  // 'days_till_next_available_date' attribute is the calculation for the nr of days between
  // the selected date (if it has no availability) and the next available date.
  // if the selected date has availability, we’ll send ‘0’"
  let daysTillNextAvailableDate = 0;
  if (selectedDateTimeslots.length === 0) {
    if (!nextAvailableDateFromSelectedDate) {
      daysTillNextAvailableDate = -1;
    } else if (nextAvailableDateFromSelectedDate) {
      const nextAvailableDate = dayjs(nextAvailableDateFromSelectedDate.date);
      daysTillNextAvailableDate = nextAvailableDate.diff(selectedDate, 'day');
    }
  }

  const dateSelectedAttributes: SDKEventAttrs = {
    country: channel.country.countryCode,
    platform: 'web',
    is_web_mobile: isMobile,
    time_slot_count: selectedDateTimeslots.length,
    no_availability: selectedDateTimeslots.length === 0,
    days_from_current_date: daysDifference,
    days_till_next_available_date: daysTillNextAvailableDate,
  };

  return dateSelectedAttributes;
};
